import React from "react";
import RegisterForm from "./RegisterForm";
import "./registerV2.css";

export default function RegisterV2() {
  return (
    <div className="registerV2">
      <RegisterForm />
    </div>
  );
}
